import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { logger } from '@/lib/logger';
import { Button } from '@/components/ui/button';
import { useUILanguage } from '@/hooks/useUILanguage';

type LanguageSwitcherProps = {
  teamId: string;
  uid?: string;
};

export function LanguageSwitcher({ teamId, uid }: LanguageSwitcherProps) {
  const { t } = useTranslation('common');
  const { lang, setLang } = useUILanguage({ teamId, uid, defaultLang: 'nl' });

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-9"
          aria-label={t('accessibility.changeLanguage')}
        >
          <Globe className="mr-2 h-4 w-4" />
          {lang.toUpperCase()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" side="bottom">
        <DropdownMenuItem
          onSelect={() => {
            try {
              setLang('nl');
            } catch (err) {
              logger.warn('[LanguageSwitcher] Failed to set language', err);
            }
          }}
        >
          Nederlands (NL)
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => {
            try {
              setLang('en');
            } catch (err) {
              logger.warn('[LanguageSwitcher] Failed to set language', err);
            }
          }}
        >
          English (EN)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
